/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueTemplate = {
    properties: {
        category: {
            type: 'LeagueCategoryEnum',
            isRequired: true,
        },
        templateName: {
            type: 'string',
            isRequired: true,
        },
        tableRating: {
            type: 'LeagueRatingEnum',
        },
        matchSectionAmount: {
            type: 'number',
        },
        matchSectionDurationMinutes: {
            type: 'number',
        },
        matchSectionPauseDurationMinutes: {
            type: 'number',
        },
        hasPlayerStatistics: {
            type: 'boolean',
        },
        hasTeamStatistics: {
            type: 'boolean',
        },
        hasManOfTheMatch: {
            type: 'boolean',
        },
        hasLineup: {
            type: 'boolean',
        },
        hasFeed: {
            type: 'boolean',
        },
        hasScorers: {
            type: 'boolean',
        },
        hasSquad: {
            type: 'boolean',
        },
        hasBetting: {
            type: 'boolean',
        },
        amountPlayers: {
            type: 'number',
        },
        main: {
            type: 'boolean',
        },
        hasPlayerRating: {
            type: 'boolean',
        },
        divisionId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
